import { login, logout, getInfo } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    roles: [],
    buttons: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_BUTTONS: (state, buttons) => {
      state.buttons = buttons
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      console.log('aaaaa');

      const username = userInfo.username.trim()
      console.log('bbbbb',username);

      return new Promise((resolve, reject) => {
        login(username, userInfo.password).then(response => {
          // Keep handoff credentials out of the browser console.
          const tokenStr = response.data
          setToken(tokenStr)
          commit('SET_TOKEN', tokenStr)
          resolve(response.sunnyHandoff || null)
        }).catch(error => {
          console.log('error',error);

          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          const data = response.data
          if (data.sunnyRestricted) {
            commit('SET_NAME', data.username)
            commit('SET_ROLES', [])
            commit('SET_BUTTONS', [])
            resolve(response)
            return
          }
          if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', data.roles)
          } else {
            reject('getInfo: roles must be a non-null array !')
          }
          // 处理buttons数据，提取name字段生成数组
          if (data.buttons && data.buttons.length > 0) {
            const buttonNames = data.buttons.map(button => button.name)
            commit('SET_BUTTONS', buttonNames)
          } else {
            commit('SET_BUTTONS', [])
          }
          commit('SET_NAME', data.username)
          commit('SET_AVATAR', data.icon)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_BUTTONS', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        commit('SET_BUTTONS', [])
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js